import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { mapLanguageToPageProps } from 'interview/i18n'
import Layout from 'interview/components/layout'
import Withdraw from 'interview/components/withdraw'

const propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  params: PropTypes.shape({
    token: PropTypes.string,
  }).isRequired,
}

export function WithdrawPage({ params }) {
  return <Withdraw params={params} />
}

WithdrawPage.propTypes = propTypes

export default connect(mapLanguageToPageProps())(WithdrawPage)
